var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBroadcastLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.022,
    x2: 512.02,
    y1: 256.001,
    y2: 256.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M115.688 256.086H60.551a12 12 0 1 1 0-24h55.137a12 12 0 1 1 0 24zM48.55 207.559a12 12 0 0 1 12-12h38.419a12 12 0 1 1 0 24H60.551a12 12 0 0 1-12-12zm416.42 57.009h-4.553v-46.1h4.553a23.049 23.049 0 1 1 0 46.1zm-28.552 142.171a23.049 23.049 0 1 1-46.1 0V76.3a23.049 23.049 0 1 1 46.1 0zM164.838 312.1V170.93c33.52-.59 60.4-2.685 87.171-9.61 33.893-8.775 67.092-25.075 114.312-56.557v273.509C319.1 346.79 285.9 330.49 252.009 321.72c-26.769-6.926-53.637-9.016-87.171-9.62zm-12.021 142.463L118.68 457.7l-11.21-121.77c2.76-.01 5.5-.01 8.171-.019 9.266-.019 17.98-.028 26.25-.01zM24.022 241.517a70.5 70.5 0 0 0 70.417 70.423q11.027 0 21.15-.029c8.851-.019 17.239-.028 25.25-.019v-140.75c-8.011.019-16.4 0-25.25-.014q-10.14-.028-21.15-.033a70.5 70.5 0 0 0-70.417 70.422zm440.948-47.045h-4.553V76.3a47.04 47.04 0 0 0-94.077-.533c-104.07 71.659-136.179 71.6-250.7 71.357-6.779-.014-13.832-.028-21.2-.028a94.421 94.421 0 0 0-11.13 188.183l12.578 136.575a11.993 11.993 0 0 0 11.931 10.9 9.911 9.911 0 0 0 1.123-.052l58.029-5.336a12.01 12.01 0 0 0 10.851-13.054l-11.814-128.179c76.6 1.457 113.331 11.237 200.332 71.139a47.04 47.04 0 0 0 94.077-.533V288.572h4.553a47.05 47.05 0 1 0 0-94.1z",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastLogo);
export default __webpack_public_path__ + "static/media/broadcastLogo.a6ab7da0f995537fb05378e103525640.svg";
export { ForwardRef as ReactComponent };